<template>
  <v-container grid-list-xl>
    <v-layout
      row
      wrap
    >
      <v-flex
        lg12
        sm12
        xs12
        class="pt-0"
      >
        <v-card class="app-card">
          <v-card-title class="app-card-title mb-0">
            Detalhes do Pedido
          </v-card-title>
          <v-card-text
            v-if="detail.data"
            class="app-card-content pl-0 pr-0"
          >
            <section class="status-area">
              <h4>
                <strong class="mr-1">Número:</strong>
                <span>{{ detail.data.id }}</span>
              </h4>
              <h4>
                <strong class="mr-1">Tipo Pedido:</strong>
                <span>{{ detail.data.tipoPedido | tipoPedido }}</span>
              </h4>
              <h4>
                <strong class="mr-1">Situação:</strong>
                <span>{{ detail.data.status | statusPedido }}</span>
              </h4>
            </section>
            <v-card flat>
              <v-card-text class="mt-3 detail-content">
                <v-row>
                  <v-col
                    :lg="4"
                    :md="4"
                    :sm="6"
                  >
                    <v-text-field
                      label="Transportadora"
                      outlined
                      disabled
                      :value="
                        detail.data.veiculoTransportadora
                          ? detail.data.veiculoTransportadora.transportadora
                            .razaosocial
                          : detail.data.transportadora.razaosocial
                      "
                    />
                  </v-col>
                  <v-col
                    :lg="4"
                    :md="4"
                    :sm="6"
                  >
                    <v-text-field
                      label="CNPJ"
                      outlined
                      disabled
                      :value="
                        detail.data.veiculoTransportadora
                          ? detail.data.veiculoTransportadora.transportadora
                            .cnpj
                          : detail.data.transportadora.cnpj
                      "
                    />
                  </v-col>
                  <v-col
                    v-if="!detail.data.tipoPedido.includes('TRANSPORTADORA')"
                    :lg="4"
                    :md="4"
                    :sm="6"
                  >
                    <v-text-field
                      label="Veículo/Placa"
                      outlined
                      disabled
                      :value="getLicensePlate(detail.data)"
                    />
                  </v-col>
                </v-row>
                <DocumentsList
                  v-if="
                    detail.data.documentosAnexos &&
                      detail.data.documentosAnexos.length
                  "
                  :documentos="detail.data.documentosAnexos"
                  :type-solicitation="detail.data.tipoPedido"
                  @uploaded="uploadedDocument"
                />
                <DocumentosForm
                  v-if="detail.data.status !== 'CANCELADO'"
                  :resource-id="Number(detail.data.id)"
                  :type-solicitation="detail.data.tipoPedido"
                  :sexo="pedidoInfo.sexo"
                  @uploaded="uploadedDocument"
                />
              </v-card-text>
            </v-card>
          </v-card-text>
          <section
            v-if="detail.isLoading"
            class="isLoading"
          >
            <v-progress-circular
              indeterminate
              color="primary"
            />
          </section>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import DocumentsList from "../components/documentos/List";
import DocumentosForm from "../components/documentos/Form";
import PedidoService from "@/services/sit-pedidos/pedido.service";

// Vuex Store - Sit Pedidos (mapping actions and states)
const actions = mapActions("sitPedidos", [
  "setDetailData",
  "setDetailIsLoading",
  "clearDetailData",
  "setFormDocuments",
]);
const state = mapState("sitPedidos", ["detail", "form"]);

export default {
  components: {
    DocumentsList,
    DocumentosForm,
  },
  data: () => ({
    pedidoInfo: {
      sexo: "",
    },
  }),
  computed: {
    ...state,
  },
  mounted() {
    this.iniData();
  },
  destroyed() {
    this.clearDetailData();
  },
  methods: {
    loadPedidoInfo(id, tipoPedido) {
      if (tipoPedido !== "SUBSTITUICAO_COOPERADO") {
        this.pedidoInfo = { sexo: "" };
        return;
      }

      PedidoService.getPedidoInfo(Number(id)).subscribe(
        (res) => {
          this.pedidoInfo = res?.cooperadoEntrante || { sexo: "" };
        },
        () => {
          this.pedidoInfo = { sexo: "" };
        }
      );
    },

    getLicensePlate({ veiculo, veiculoTransportadora }) {
      if (veiculo) return veiculo.placa;

      if (veiculoTransportadora) return veiculoTransportadora.veiculo.placa;

      return "-";
    },

    iniData() {
      const {
        params: { id },
      } = this.$route;

      this.pedidoInfo = {
        sexo: "",
      };

      this.setDetailIsLoading(true);
      PedidoService.show(id).subscribe(
        (res) => {
          this.setDetailData(res);
          this.loadPedidoInfo(id, res?.tipoPedido);
          this.setDetailIsLoading(false);
        },
        (error) => {
          this.$router.push({ name: "pedidos-list" });
          this.setDetailIsLoading(false);
        }
      );
    },
    uploadedDocument(value) {
      if (value) {
        this.iniData();
      }
    },
    ...actions,
  },
};
</script>

<style lang="scss" scoped>
.isLoading {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.6);
  margin: 0px;
}
.status-area {
  display: flex;
  align-content: center;
  align-items: flex-start;
  border-bottom: solid 1px #e5e5e5;
  text-align: center;
  justify-content: center;
  flex-direction: column;
  padding: 10px 15px;
  h4 {
    text-transform: uppercase;
    flex: 1;
    span {
      font-size: 15px;
      font-weight: 400;
    }
    strong {
      font-size: initial;
    }
  }
}

.detail-content {
  padding-bottom: 24px !important;
}
</style>
